import http from "./httpService";
const apiEndpoint = "/campaigns";

function getAllCalls(projectId) {
  return http.get(`${apiEndpoint}/getAllWhiteLabelCampaigns/${projectId}`);
}

function addToCampaign(projectId, data) {
  return http.post(
    `${apiEndpoint}/whiteLabelCreateCampaign/${projectId}`,
    data
  );
}

function bulkUpload(projectId, data) {
  return http.post(
    `${apiEndpoint}/whiteLabelCampaignBatchUpload/${projectId}`,
    data
  );
}

function deleteFromCampaign({ projectId, campaignId }) {
  return http.delete(
    `${apiEndpoint}/deleteWhiteLabelCampaign/${projectId}/${campaignId}`
  );
}

function getAllCampaignsPaginated(projectId, params) {
  return http.get(`${apiEndpoint}/whitelabelGetAllCampaignsPaginated/${projectId}`, {
    params,
  });
}

function getFilteredCampaignsPaginated(projectId, params, payload) {
  return http.post(`${apiEndpoint}/whitelabelFilterCampaigns/${projectId}`, payload, {
    params,
  });
}

function deleteBulkCampaigns({ workspaceId, payload }) {
  return http.delete(`${apiEndpoint}/whitelabelBulkDeleteCampaigns/${workspaceId}`, {
    headers: { "Content-Type": "application/json" },
    data: payload,
  });
}

function requestCampaignReport(projectId, payload) {
  return http.post(`${apiEndpoint}/whiteLabelRequestCampaignReport/${projectId}`, payload);
}

export {
  getAllCalls,
  addToCampaign,
  bulkUpload,
  deleteFromCampaign,
  getAllCampaignsPaginated,
  getFilteredCampaignsPaginated,
  deleteBulkCampaigns,
  requestCampaignReport
};
